<!--
  ~ Copyright 2020 Google LLC.
  ~ SPDX-License-Identifier: Apache-2.0
  -->

<form [formGroup]="dataForm" (ngSubmit)="onSubmit()">
  <div>
    <label for="file-box">
      Upload binary data file here:
    </label>
    <br><br>
    <input id="file-box"
           type="file"
           formControlName="file"
           accept=".pb"
           (change)="onFileChange($event)">
  </div>

  <br>
  <p> OR </p>
  <br>

  <div>
    <label for="data-text-box">
      Input JSON data here:
      *this takes priority
    </label>
    <br><br>
    <textarea id="data-text-box" formControlName="text"></textarea>
  </div>

  <button type="submit">Submit</button>
</form>


